import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62cf4b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 bg-white opacity-60",
  style: {"z-index":"9999"}
}
const _hoisted_2 = { class: "border-b pt-2 pb-4 my-3 border-gray-500" }
const _hoisted_3 = { class: "flex text-sm text-gray-600 font-normal" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "-", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "py-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = { class: "font-bold text-md" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "rounded-md p-4 bg-yellow-100"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "shrink-0" }
const _hoisted_15 = { class: "ml-3" }
const _hoisted_16 = { class: "text-sm font-medium text-red-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSection = _resolveComponent("LoadingSection")!
  const _component_PlannerComments = _resolveComponent("PlannerComments")!
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_ImagesComparison = _resolveComponent("ImagesComparison")!
  const _component_SlideOver = _resolveComponent("SlideOver")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingSection, { loading: _ctx.loading }, null, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SlideOver, {
      open: _ctx.open,
      onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closed'))),
      maxWidth: "1000px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.resourceFullName), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedEvents, (event) => {
            return (_openBlock(), _createElementBlock("div", {
              key: event.id,
              class: "py-1 flex items-center gap-1 justify-between flex-wrap"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
              event.getData('type') === 'planned' ? 'plannedBg' : 'bg-green',
              'whitespace-nowrap rounded-lg px-2 py-0.5 my-1 text-sm text-white font-normal',
            ])
              }, _toDisplayString(event.getData("type") === "planned"
                ? _ctx.$t("analytics.planner.target_period")
                : _ctx.$t("analytics.planner.actual_period")), 3),
              _createElementVNode("div", _hoisted_3, [
                (event.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(event.startDate
                  ? _ctx.format(event.getData("startDate"), "dd.MM.yyyy")
                  : _ctx.$t("analytics.planner.not_started_event")), 1))
                  : _createCommentVNode("", true),
                _hoisted_5,
                (event.endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(event.endDate ? _ctx.format(event.getData("endDate"), "dd.MM.yyyy") : ""), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, "  (" + _toDisplayString(`${_ctx.formatNumber(_ctx.getWorkingDays(event))} ${_ctx.$t(
                  "analytics.planner.working_days_label",
                  _ctx.getWorkingDays(event),
                )}`) + ") ", 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_component_PlannerComments, {
            sourceId: _ctx.sourceId,
            key: _ctx.plannerCommentsKey,
            onCommentAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('commentAdded', $event))),
            onCommentDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('commentDeleted', $event)))
          }, null, 8, ["sourceId"]))
        ]),
        (_ctx.cameraList.length && _ctx.actualEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cameraList, (camera) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: camera,
                  class: "my-6 border-t py-4"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("app_features.compare")), 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.downloadImages(camera))
                    }, [
                      _createVNode(_component_ArrowDownTrayIcon, { class: "h-6" })
                    ], 8, _hoisted_11)
                  ]),
                  _createVNode(_component_ImagesComparison, {
                    camera: camera,
                    initialAfterDate: _ctx.initialAfterDate,
                    initialBeforeDate: _ctx.initialBeforeDate
                  }, null, 8, ["camera", "initialAfterDate", "initialBeforeDate"])
                ]))
              }), 128))
            ]))
          : (_ctx.actualEvent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.InformationCircleIcon), {
                      class: "h-5 w-5 text-yellow-400",
                      "aria-hidden": "true"
                    }))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("err.planner.no_camera_per_item")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}